<a *ngFor="let school of schools" [href]="'//' + school.homepage_url">
  <button class="hover:bg-orangeHover duration-100 mx-0 p-2">
    <img
      style="height: 47px; width: 91px"
      [src]="school.getLogoPath()"
      [alt]="'Logo der ' + school.name"
    />
  </button>
</a>
